import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function RHFTextField({ name, helperText, type, InputProps, ...other }) {
  const { control } = useFormContext();
  
  // State to handle password visibility
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          // If type is password and showPassword is true, switch to 'text', otherwise keep original type
          type={type === 'password' && showPassword ? 'text' : type}
          value={field.value ?? ''}
          onChange={(event) => {
            if (type === 'number') {
              const val = event.target.value;
              field.onChange(val === '' ? '' : Number(val));
            } else if (type === 'tel') {
              // Filter to only allow digits
              const val = event.target.value.replace(/[^0-9]/g, '');
              field.onChange(val);
            } else {
              field.onChange(event.target.value);
            }
          }}
          InputProps={{
            ...InputProps,
            // Only add the eye icon if the original type is 'password'
            endAdornment: type === 'password' ? (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                </IconButton>
              </InputAdornment>
            ) : (InputProps?.endAdornment || null),
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}

RHFTextField.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  InputProps: PropTypes.object,
};